const ABOUT_YOU = {
  TITLE: 'SOBRE TI',
  ACCEPT: 'Guardar',
  CANCEL: 'Cancelar'
};

const AWARDS = {
  TITLE: 'PREMIOS',
  NAME: 'Nombre del premio',
  DATE: 'Fecha',
  ACCEPT: 'Guardar',
  CANCEL: 'Cancelar'
};

const DELETE_EXPERIENCE_PAST = {
  TITLE: 'ELIMINAR EXPERIENCIA',
  DESCRIPTION: '¿Está seguro que desea eliminar la experiencia?',
  ACCEPT: 'Eliminar',
  CANCEL: 'Cancelar'
};

const DELETE_FILE = {
  TITLE: 'ELIMINAR ARCHIVO',
  DESCRIPTION: '¿Está seguro que desea eliminar el archivo?',
  ACCEPT: 'Eliminar',
  CANCEL: 'Cancelar'
};

const DELETE_FOLDER = {
  TITLE: 'ELIMINAR CARPETA',
  DESCRIPTION: '¿Está seguro que desea eliminar la carpeta?',
  ACCEPT: 'Eliminar',
  CANCEL: 'Cancelar'
};

const EDUCATION = {
  TITLE: 'MI FORMACIÓN',
  TITLE_LABEL: 'Titulación(*)',
  CENTER_LABEL: 'Centro(*)',
  CERTIFICATE_LABEL: 'Nombre del título(*)',
  DATE_FROM_LABEL: 'Desde(*)',
  DATE_UNTIL_LABEL: 'Hasta(*)',
  ACCEPT: 'Guardar',
  CANCEL: 'Cancelar'
};

const EXPERIENCE = {
  TITLE_ADD: 'AÑADIR EXPERIENCIA PROFESIONAL',
  TITLE_MOD: 'MODIFICAR EXPERIENCIA PROFESIONAL ACTUAL',
  TITLE_OLD: 'MODIFICAR EXPERIENCIA PROFESIONAL PASADA',
  COMPANY_NAME: 'Empresa',
  POSITION: 'Cargo',
  DESCRIPTION: 'Descripcion',
  FROM: 'Desde',
  UNTIL: 'Hasta',
  MONTH: 'Mes',
  YEAR: 'Año',
  CURRENT_WORKER: 'Trabajo actual',
  RETURN: 'VOLVER',
  SAVE_AND_ADD: 'Guardar y añadir otro',
  ACCEPT: 'Guardar',
  CANCEL: 'Cancelar'
};

const INTERESTS = {
  TITLE: 'INTERESES',
  INTEREST: 'Interés',
  ACCEPT: 'Guardar',
  CANCEL: 'Cancelar'
};

const CHILDREN = {
  TITLE: 'HIJOS',
  NAME_LABEL: 'Nombre(*)',
  SURNAME_LABEL: 'Apellidos(*)',
  BIRTHDATE_LABEL: 'Fecha de nacimiento(*)',
  ACCEPT: 'Guardar',
  CANCEL: 'Cancelar'
};

const LANGUAGE = {
  TITLE: 'IDIOMAS',
  NAME: 'Idioma(*)',
  DEGREE: 'Título(*)',
  CERTIFICATION: 'Certificación',
  PROFICIENCY: 'Nivel',
  ACCEPT: 'Guardar',
  CANCEL: 'Cancelar'
};

const RRSS = {
  TITLE: 'REDES SOCIALES',
  SOCIAL: ['Facebook', 'Twitter', 'Linkedin', 'Instagram', 'Vimeo'],
  ACCEPT: 'Guardar',
  CANCEL: 'Cancelar'
};

const SAVE = {
  TITLE: 'GUARDAR DATOS',
  DESCRIPTION: '¿Estás seguro que quieres guardar los cambios?',
  ACCEPT: 'Guardar',
  CANCEL: 'Cancelar'
};

const HOBBIES = {
  TITLE: 'HOBBIES',
  CATEGORY: 'Categoria',
  HOBBY: 'Hobby',
  ACCEPT: 'Guardar',
  CANCEL: 'Cancelar'
};

const TRAINING = {
  TITLE: 'FORMACIÓN',
  TRAINING: 'Formación',
  ACCEPT: 'Guardar',
  CANCEL: 'Cancelar'
};

const VOLUNTEER = {
  TITLE: 'VOLUNTARIADOS',
  ORGANIZATION: 'Organización (*)',
  FUNCTION: 'Función (*)',
  ACCEPT: 'Guardar',
  CANCEL: 'Cancelar'
};
const DELETE_COMMENT = {
  TITLE: 'ELIMINAR COMENTARIO',
  DESCRIPTION: '¿Está seguro que desea eliminar el comentario?',
  ACCEPT: 'Eliminar',
  CANCEL: 'Cancelar'
};

export {
  DELETE_COMMENT,
  ABOUT_YOU,
  AWARDS,
  DELETE_EXPERIENCE_PAST,
  DELETE_FILE,
  DELETE_FOLDER,
  EDUCATION,
  EXPERIENCE,
  CHILDREN,
  INTERESTS,
  LANGUAGE,
  RRSS,
  SAVE,
  HOBBIES,
  TRAINING,
  VOLUNTEER
};
